/**
 * The figures a broker reads off first. Only the ones the listing actually has
 * appear, so the strip never shows a column of zeroes.
 */
const ListingSpecStrip = ({ listing }) => {
  const specs = [
    { key: "Beds", value: listing.beds },
    { key: "Baths", value: listing.baths },
    { key: "Sq Ft", value: listing.sqFt },
    { key: "Acres", value: listing.acreage },
    { key: "Built", value: listing.yearBuilt },
    { key: "Lot Sq Ft", value: listing.lotSize },
  ].filter((s) => s.value || s.value === 0 ? Boolean(s.value) : false);

  if (!specs.length) return null;

  return (
    <div className="my-3 flex flex-wrap overflow-hidden rounded-lg border border-light_gray bg-white shadow-card">
      {specs.map((s) => (
        <div
          key={s.key}
          className="min-w-[80px] flex-1 border-r border-light_gray px-2 py-3 text-center last:border-r-0"
        >
          <div className="text-lg font-black text-dark_gray">
            {/* Year built is a label, not a quantity — never group its digits. */}
            {s.key === "Built" ? s.value : s.value.toLocaleString()}
          </div>
          <div className="text-[10px] uppercase tracking-wide text-gray-400">
            {s.key}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ListingSpecStrip;
